export const colors = {
    header_background: "#000",
    sidebar_background: "#000",
    primary: "#FF0101",
    kcal: "#FF0000",
    protein: "#4AB8FF",
    carbohydrate: "#FDCC0C",
    lipid: "#FD5181",
    radarchart_background: "#282D30",
    linechart_background: "#FF0000",
    barchart_background: "#FBFBFB",
    barchart: {
        weight: "#282D30",
        calories_burned: "#E60000"
    }
}